import { useTranslations } from 'next-intl';

import { UNA_FLEX_LINK } from '@web/features/const';

export interface ICommandDefinition {
  message: Parameters<ReturnType<typeof useTranslations>>[0];
  userInput?: Parameters<ReturnType<typeof useTranslations>>[0];
  response?: Parameters<ReturnType<typeof useTranslations>['rich']>;
  externalUrl?: string;
  commands?: Array<ICommandDefinition>;
}

export const EXPLAIN_STAKING_COMMAND: ICommandDefinition = {
  message: 'STAKING_TERMINAL_WHAT_COMMAND',
  response: ['STAKING_TERMINAL_WHAT_MESSAGE'],
};
export const EXPLAIN_UNSTAKE_COMMAND: ICommandDefinition = {
  message: 'STAKING_TERMINAL_HOW_COMMAND',
  response: ['STAKING_TERMINAL_HOW_MESSAGE'],
};
export const EXPLAIN_BOOST_COMMAND: ICommandDefinition = {
  message: 'STAKING_TERMINAL_BOOST_COMMAND',
  response: ['STAKING_TERMINAL_BOOST_MESSAGE'],
};
export const EXPLAIN_TIMER_COMMAND: ICommandDefinition = {
  message: 'STAKING_TERMINAL_TIMER_COMMAND',
  userInput: 'STAKING_TERMINAL_TIMER_INPUT',
  response: ['STAKING_TERMINAL_TIMER_MESSAGE'],
};

export const UNA_FLEX_COMMAND: ICommandDefinition = {
  message: 'STAKING_TERMINAL_UNA_FLEX_COMMAND',
  externalUrl: UNA_FLEX_LINK,
};

export const HELP_COMMAND: ICommandDefinition = {
  message: 'STAKING_TERMINAL_HELP_COMMAND',
  userInput: 'STAKING_TERMINAL_HELP_MESSAGE',
  commands: [EXPLAIN_STAKING_COMMAND, EXPLAIN_UNSTAKE_COMMAND],
};
